import { Component, Input } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { localeDe, localeFr, localeIt } from '@mobiscroll/angular';
import { AnimalDateType } from 'src/app/api/models';
import { CustomTranslationService } from 'src/app/shared/translation/custom-translation.service';
import { Languages } from 'src/app/shared/translation/languages.enum';

@Component({
  selector: 'diana-select-date-type',
  standalone: false,
  templateUrl: './select-date-type.component.html',
  styleUrl: './select-date-type.component.scss',
})
export class SelectDateTypeComponent {

  @Input() formGroup!: FormGroup;
  @Input() dateTypesAvailable: AnimalDateType[] = [];
  @Input() formArrayDateTypes!: FormArray;
  @Input() index!: number;

  public localeDatePicker = localeDe;
  public currentLanguage: Languages = Languages.de;
  public maxDate = new Date();


  constructor(
    private translateSrv: CustomTranslationService,
  ) {

    this.currentLanguage = this.translateSrv.currentLang as Languages;

    switch (this.translateSrv.currentLang) {
      case Languages.de:
        this.localeDatePicker = localeDe;
        break;

      case Languages.fr:
        this.localeDatePicker = localeFr;
        break;

      case Languages.it:
        this.localeDatePicker = localeIt;
        break;
    }
  }


  public generateDropdown(): AnimalDateType[] {
    let dateTypesDropdown = [...this.dateTypesAvailable];
    const selectedDateTypeIds: string[] = [];

    this.formArrayDateTypes.controls.forEach(selected => {
      const selectedDateType = selected.get('dateType')?.value;

      if (
        selectedDateType?.id &&
        this.formGroup.get('dateType')?.value?.id !== selectedDateType.id
      ) {
        selectedDateTypeIds.push(selectedDateType.id);
      }
    });

    if (selectedDateTypeIds.length > 0) {
      dateTypesDropdown = this.dateTypesAvailable.filter(
        available =>
          !selectedDateTypeIds.includes(available.id)
      );
    }
    return dateTypesDropdown;
  }
}